<div [formGroup]="form" class="grid gap-6">
    <mat-form-field appearance="fill">
        <mat-label>Á hvaða sviði?</mat-label>
        <mat-select formControlName="area">
            @for (area of areas; track area) {
                <mat-option [value]="area">{{ area }}</mat-option>
            }
        </mat-select>
        <mat-error>Veldu svið</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>Hvert er verkefnið?</mat-label>
        <mat-select formControlName="projectType">
            @for (projectType of projectTypes; track projectType) {
                <mat-option [value]="projectType">{{ projectType }}</mat-option>
            }
        </mat-select>
        <mat-error>Veldu verkefni</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>Stutt lýsing</mat-label>
        <textarea matInput rows="6" formControlName="description"></textarea>
        <mat-hint align="end">{{ form.get('description')?.value?.length ?? 0 }}/2000</mat-hint>
        <mat-error>Lýsing er skyldureitur</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>Tengsl sem valda hagsmunaárekstrum</mat-label>
        <textarea matInput rows="6" formControlName="conflictingRelations"></textarea>
        <mat-hint align="end">{{ form.get('conflictingRelations')?.value?.length ?? 0 }}/2000</mat-hint>
        <mat-error>Tengsl er skyldureitur</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>Hvaða ráðstafana var gripið til?</mat-label>
        <textarea matInput rows="6" formControlName="measuresTaken"></textarea>
        <mat-hint align="end">{{ form.get('measuresTaken')?.value?.length ?? 0 }}/2000</mat-hint>
        <mat-error>Ráðstafanir er skyldureitur</mat-error>
    </mat-form-field>
</div>
